import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Paper, TextField, Typography } from '@mui/material';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import { useAuth } from '@/auth/useAuth';

const EXAMPLE_EMAIL = 'test.abitarein@gmail.com';

export default function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [touched, setTouched] = useState(false);

  const isValid = email.trim().length > 0 && email.includes('@');

  function handleSubmit(event: FormEvent<HTMLFormElement>): void {
    event.preventDefault();
    setTouched(true);
    if (!isValid) return;
    login(email.trim());
    navigate('/apartments');
  }

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Paper
        component="form"
        onSubmit={handleSubmit}
        elevation={0}
        sx={{
          p: { xs: 3, sm: 5 },
          width: '100%',
          maxWidth: 420,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3,
        }}
      >
        <HomeWorkOutlinedIcon sx={{ fontSize: 48, color: 'secondary.main' }} aria-hidden="true" />

        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h3" gutterBottom>
            Accedi al tuo configuratore
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Inserisci l&apos;email associata alla tua configurazione Home Configurator.
          </Typography>
        </Box>

        <TextField
          id="login-email"
          label="Email"
          type="email"
          fullWidth
          required
          autoFocus
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={touched && !isValid}
          helperText={
            touched && !isValid
              ? "Inserisci un indirizzo email valido"
              : `Esempio: ${EXAMPLE_EMAIL}`
          }
          inputProps={{ 'aria-describedby': 'login-email-helper' }}
        />

        <Button type="submit" variant="contained" color="primary" fullWidth size="large">
          Entra
        </Button>
      </Paper>
    </Box>
  );
}
